import React from 'react'
import UnitedStatesSelect from '../../../helpers/General/UnitedStatesSelect';

import { browserHistory } from 'react-router'
import { modal } from '../../../core/utilities/modal';
import { rentersInsurance } from '../../../core/controllers/RentersInsurance';

export default class LibertyMutualTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            optIn: false,
            showDisclosure: false,
            dob: '',
            policyData: null,
            materialType: 'Wood Exterior',
            financialKey: null,
            paymentAccountId: null,
            purchaseData: null,
            hasInsurance: false,
            medicalCoverage: null,
            liabilityCoverage: null,
            personalPropertyCoverage: null,
            paymentType: null,
            priorAddress: '',
            priorCity: '',
            priorState: '',
            priorZip: '',
            moreThanSixMonths: 'true'
        }
    }

    componentDidMount() {
        var self = this;
        rentersInsurance.getInsurance(function (response) {
            self.setState({
                hasInsurance: response.data ? true : false,
                insurance: response.data
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {

    }

    componentDidUpdate() {
        if (this.state.step == 5) {
            this.miniApp = document.getElementById('miniAppIframe');
            // Set the miniApp origin to use for postMessage calls and origin validation
            this.miniApp.origin = process.env.LIBERTY_ORIGIN;

            // Flag the mini-app as not being ready
            this.miniApp.ready = false;

            // Give the mini-app a blank token (will be set when mini-app is ready)
            this.miniApp.token = '';
            if (window.addEventListener) {
                window.addEventListener('message', this.miniAppEventListener.bind(this), false);
            } else {
                window.attachEvent('onmessage', this.miniAppEventListener.bind(this));
            }

            this.initializeMiniApp();
        } else {
            jQuery("#login").attr('disabled', false);
        }
    }

    miniAppEventListener(message) {
        var self = this;
        // message.data will contain the message string received
        // message.origin contains the origin string of the parent who sent the message
        // message.source will contain a reference to the window object that sent the message
        if (message.origin === this.miniApp.origin) {
            // Convert the message data string to an object
            var messageData = JSON.parse(message.data);
            // Store the token provided by the mini-app; it will be required in all subsequent events sent to mini-app
            this.miniApp.token = messageData.token;

            if (messageData.event === 'ready') {
                // Flag the mini-app as ready to break out of the initialization loop 
                this.miniApp.ready = true;

                // Send update with initial configuration data
                this.updateMiniApp();
            }
            else if (messageData.event === 'unload') {
                // Something caused the mini-app to unload (possibly user refresh); re-initialize it
                this.initializeMiniApp();
            }
            else if (messageData.event === 'error') {
                modal.showInfo('Unable to process your request, please verify the information entered and try again.', "danger", "top", "center");
                jQuery("#login").attr('disabled', false);
            }
            else if (messageData.event === 'success') {
                jQuery("#login").attr('disabled', false);
                self.paymentAccountId = messageData.data.paymentAccount.paymentAccountId
                self.selectStep(7);
            }
        }
    }

    initializeMiniApp() {
        var self = this;
        // Set up the outgoing event as an object
        var readyEvent = {
            event: 'ready'
        };

        // Send the ready event every half-second until the mini-app is ready or we exceed a 30-second timeout
        var timeElapsed = 0;
        var intervalHandle = setInterval(function () {
            // If mini-app isn't ready and timer is less than 30 seconds, send ready event
            if (self.miniApp.contentWindow != null && !self.miniApp.ready && timeElapsed < 30000) {
                // Send ready event string to the mini-app iframe via postMessage
                self.miniApp.contentWindow.postMessage(JSON.stringify(readyEvent), self.miniApp.origin);
            } else {
                // Mini-app is ready or timeout exceeded
                clearInterval(intervalHandle);
                intervalHandle = undefined;

                if (!self.miniApp.ready) {
                    // Retry initialization or show loading error to user
                }
            }

            timeElapsed += 500;
        }, 500);
    }

    updateMiniApp() {
        // Set up the outgoing event as an object
        // Certain properties will be required in the data object; refer to documentation
        var updateEvent = {
            event: 'update',
            token: this.miniApp.token,
            data: {
                config: {
                    requestSourceCode: 'CFI',
                    productTypeCode: 'ONLINE',
                    accountTypeSelection: true
                    // css: 'http://localhost:8585/parent/parent.css'
                }
            },
            authorizeButton: {
                hidden: 'boolean',
                displayText: 'string'
            },
        };

        if (this.miniApp.contentWindow == null) {
            return;
        }

        this.miniApp.contentWindow.postMessage(JSON.stringify(updateEvent), this.miniApp.origin);
    }

    selectStep(step) {
        var self = this;

        jQuery("#login").attr('disabled', true);
        if (this.state.step == 1) {
            if (this.state.optIn && this.state.dob != '') {
                rentersInsurance.getQuote(this.state.dob, function (response) {
                    if (response.data) {
                        self.setState({
                            step: step,
                            policyData: response.data
                        });
                    }
                });
            } else {
                if (this.state.dob == '') {
                    modal.showInfo('Please enter your date of birth.', "warning", "top", "center");
                } else {
                    modal.showInfo('You need to "Opt In" before you can get a quote now.', "warning", "top", "center");
                }
                jQuery("#login").attr('disabled', false);
            }
        } else {
            if (this.state.step == 3 && step == 4) {
                rentersInsurance.reQuote(this.state.policyData.quoteId, this.state.materialType, this.state.dob, this.state, function (response) {
                    self.setState({
                        step: step,
                        policyData: response.data
                    });
                })
            } else if (this.state.step == 4 && step == 5) {
                this.setState({
                    step: step
                });
            } else if (this.state.step == 5 && step == 6) {
                rentersInsurance.getFinancialKey(this.state.policyData, function (response) {
                    var authorizeEvent = {
                        event: 'authorize',
                        token: self.miniApp.token,
                        data: {
                            config: {
                                requestSourceCode: 'CFI',
                                productTypeCode: 'ONLINE',
                                secureKey: response.data.key
                            }
                        }
                    };

                    if (self.miniApp.contentWindow == null) {
                        return;
                    }

                    self.miniApp.contentWindow.postMessage(JSON.stringify(authorizeEvent), self.miniApp.origin);
                });
            } else if (step == 7) {
                rentersInsurance.purchase(this.state.policyData, this.paymentAccountId, this.state.paymentType, function (response) {
                    self.setState({
                        step: step,
                        purchaseData: response.data
                    });
                });
            } else {
                this.setState({
                    step: step
                });
            }
        }
    }

    optIn() {
        this.setState({ optIn: !this.state.optIn })
    }

    showDisclosure() {
        this.setState({ showDisclosure: !this.state.showDisclosure })
    }

    handleDobChange(e) {
        this.setState({ dob: e.target.value });
    }

    handleMaterialChange(e) {
        this.setState({ materialType: e.target.value });
    }

    medicalCoverage(e) {
        this.setState({
            medicalCoverage: e.target.value
        });
    }

    liabilityCoverage(e) {
        this.setState({
            liabilityCoverage: e.target.value
        });
    }

    personalPropertyCoverage(e) {
        this.setState({
            personalPropertyCoverage: e.target.value
        });
    }

    handleAddress(e) {
        this.setState({
            priorAddress: e.target.value
        });
    }

    handleCity(e) {
        this.setState({
            priorCity: e.target.value
        });
    }

    handleState(e) {
        this.setState({
            priorState: e.target.value
        });
    }

    handleZip(e) {
        this.setState({
            priorZip: e.target.value
        });
    }

    hanldeMoreThanSizMonths(e) {
        this.setState({
            moreThanSixMonths: e.target.value
        });
    }

    paymentTypeChange(e) {
        this.setState({
            paymentType: e.target.value
        });
    }

    render() {
        var self = this;
        const dob = this.state.dob;
        const policyData = this.state.policyData;
        const materialType = this.state.materialType;
        const purchaseData = this.state.purchaseData;
        const hasInsurance = this.state.hasInsurance;
        const insurance = this.state.insurance;
        var medicalCoverage = this.state.medicalCoverage;
        var liabilityCoverage = this.state.liabilityCoverage;
        var personalPropertyCoverage = this.state.personalPropertyCoverage;
        var paymentType = this.state.paymentType
        const address = this.state.priorAddress;
        const city = this.state.priorCity;
        const state = this.state.priorState;
        const zip = this.state.priorZip;
        const moreThanSixMonths = this.state.moreThanSixMonths;

        var medicalCoverageHTML, liabilityCoverageHTML, personalPropertyCoverageHTML, paymentOptionsHTML = '';
        if (policyData && policyData.coverageInfo) {
            policyData.coverageInfo.map((coverage, index) => (
                coverage.hasOwnProperty('options') && (
                    <div>
                        {coverage.coverageName == "Medical Payments" && (
                            medicalCoverageHTML = (
                                <div class="col-md-6 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="assignee">Adjust {coverage.coverageName}</label>
                                        <input type="text" value={"Current: " + coverage.value} class="form-control tenant-info" name="" placeholder="" id="" disabled={true} />
                                        <br />
                                        <select class="form-control" value={medicalCoverage} onChange={self.medicalCoverage.bind(self)}>
                                            {coverage.options.map((value, index) => {
                                                return <option key={index} value={value}>{value}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                            )
                        )}
                        {coverage.coverageName == "Liability" && (
                            liabilityCoverageHTML = (
                                <div class="col-md-6 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="assignee">Adjust {coverage.coverageName}</label>
                                        <input type="text" value={"Current: " + coverage.value} class="form-control tenant-info" name="" placeholder="" id="" disabled={true} />
                                        <br />
                                        <select class="form-control" value={liabilityCoverage} onChange={self.liabilityCoverage.bind(self)}>
                                            {coverage.options.map((value, index) => {
                                                return <option key={index} value={value}>{value}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                            )
                        )}
                        {coverage.coverageName == "Personal Property" && (
                            personalPropertyCoverageHTML = (
                                <div class="col-md-6 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="assignee">Adjust {coverage.coverageName}</label>
                                        <input type="text" value={"Current: " + coverage.value} class="form-control tenant-info" name="" placeholder="" id="" disabled={true} />
                                        <br />
                                        <select class="form-control" value={personalPropertyCoverage} onChange={self.personalPropertyCoverage.bind(self)}>
                                            {coverage.options.map((value, index) => {
                                                return <option key={index} value={value}>{value}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                )
            ));
        }

        if (policyData && policyData.hasOwnProperty('paymentInfo') && (this.state.step == 4 || this.state.step == 5)) {
            paymentOptionsHTML = (
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label for="assignee">You can adjust your payment plan below</label>
                        <select class="form-control" value={paymentType} onChange={self.paymentTypeChange.bind(self)}>
                            <option key={0} value="">Change payment terms</option>
                            {policyData.paymentInfo.map((value, index) => {
                                return <option key={index} value={index}>${value.totalAmountDue} / {value.paymentFrequency} / {value.paymentType}</option>
                            })}
                        </select>
                    </div>
                </div>
            )
        }
        if (hasInsurance) {
            return (
                <div>
                    <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                    <div class="col-md-12 insurance-box">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Your policy</h4>
                            </div>
                            <div class="content">
                                <div class="row">
                                    <div class="col-md-6 col-md-offset-3 liberty-mutual-header text-center">
                                        <div class="logo">
                                            <div class="col-md-6">
                                                <p>Powered By</p>
                                            </div>
                                            <div class="col-md-12">
                                                <img src="/assets/img/liberty-mutual.png" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-md-offset-3 liberty-mutual-body">
                                        <div>
                                            <h4 class="title">Policy Information</h4>
                                            <h4 class="title">Policy Number: <b>{insurance.policy_number}</b></h4>
                                            <h4 class="title">Quote Id: <b>{insurance.quote_id}</b></h4>
                                            <h4 class="title">Documents: <a target="_blank" href={insurance.document_url}>view</a></h4>
                                            <p>If you have any questions about your policy, please contact Liberty Mutual at 1-888-445-6744</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="col-md-12">
                    <div class="row">
                        <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-12">
                                <span class="main-page-header-title">Request a Quote</span>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="content">
                            <div class="row">
                                <div class="col-md-6 col-md-offset-3 liberty-mutual-header text-center">
                                    <div class="logo">
                                            <p>Powered By</p>
                                        <div class="col-md-12">
                                            <img src="/assets/img/liberty-mutual.png" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-md-offset-3 liberty-mutual-body">
                                    {!this.state.showDisclosure && this.state.step == 1 && (
                                        <div>
                                            <h4 class="title">Need renters insurance?</h4>
                                            <p>Get an optional renters quote from Liberty Mutual Insurance now.</p>
                                            <div class="row">
                                                <div class="col-md-4 col-md-offset-4">
                                                    <div class="form-group">
                                                        <label for="phone">Date of Birth</label>
                                                        <input type="date" value={dob} class="form-control tenant-info" name="dob" placeholder="Date of Birth" id="dob" onChange={this.handleDobChange.bind(this)} />
                                                    </div>
                                                </div>
                                            </div>
                                            <p><b>Select "Opt In" and then "Get my price" for your quote.</b></p>
                                            <button type="submit" onClick={this.selectStep.bind(this, 2)} name="submit" id="login" class="btn btn-info btn-fill btn-block btn-flat" >Get my price</button>
                                            <small>By continuing, you acknowledge that you have reviewed our <span class="link" onClick={this.showDisclosure.bind(this)}>Information Disclosure.</span></small>
                                            <div class="disclosure col-md-12">
                                                <div class="col-md-2">
                                                    <input
                                                        name="optIn"
                                                        type="checkbox"
                                                        class="checkbox"
                                                        checked={this.state.optIn}
                                                        onChange={this.optIn.bind(this)} />
                                                </div>
                                                <div class="col-md-10">
                                                    <p>By Opting In, you agree to grant Liberty Mutual Insurance access to certain pieces of personal data to generate a renters insurance quote. Click here for more details.</p>
                                                </div>
                                            </div>
                                            <small>This is a non-exclusive offer for renters insurance that is solely recommended, offered, sold, and underwritten by Liberty Mutual Insurance Company and its affiliates. To review the Liberty Mutual Insurance Privacy Policy, <a href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy" target="_blank">click here</a>.  <b>This is a paid advertisement from Liberty Mutual Insurance.</b></small>
                                        </div>
                                    )}
                                    {!this.state.showDisclosure && this.state.step == 2 && (
                                        <div>
                                            <p>Thank you for your interest in a Liberty Mutual Renters insurance policy.</p>
                                            <h4 class="title">You can add renters insurance for <b>${policyData.paymentInfo[0].totalAmountDue} / {policyData.paymentInfo[0].paymentFrequency}*</b></h4>
                                            <small>*To finish your optional quote, we need some additional information. The additional information you provide may change the quoted amount displayed above.</small>
                                            <small>To continue with your quote, click “Next.”</small>
                                            <button type="submit" onClick={this.selectStep.bind(this, 3)} name="submit" id="login" class="btn btn-info btn-fill btn-block btn-flat" >Next</button>
                                            <small>This is a non-exclusive offer for renters insurance that is solely recommended, offered, sold, and underwritten by Liberty Mutual Insurance Company and its affiliates. To review the Liberty Mutual Insurance Privacy Policy, <a href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy" target="_blank">click here</a>.  <b>This is a paid advertisement from Liberty Mutual Insurance.</b></small>
                                        </div>
                                    )}
                                    {!this.state.showDisclosure && this.state.step == 3 && (
                                        <div>
                                            <h4 class="title">Adjust coverage for {policyData.cleansedInsuredAddress.addressInfo.streetAddress}</h4>
                                            <br />
                                            <div class="row">
                                                {medicalCoverageHTML}
                                                {liabilityCoverageHTML}
                                                {personalPropertyCoverageHTML}
                                                <div class="row"></div>
                                                <h4 class="title">Did you live somewhere else in the last six months?</h4>
                                                <div class="row">
                                                    <div class="col-md-4 col-md-offset-4">
                                                        <div class="form-group">
                                                            <label for="phone"></label>
                                                            <select class="form-control" value={moreThanSixMonths} onChange={this.hanldeMoreThanSizMonths.bind(this)}>
                                                                <option value='false'>Yes</option>
                                                                <option value='true'>No</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                {moreThanSixMonths == 'false' && (
                                                    <div>
                                                        <h3 class="title">Your prior address</h3>
                                                        <div class="col-md-6 col-sm-12 col-xs-12">
                                                            <div class="form-group">
                                                                <label for="assignee">Prior Address</label>
                                                                <input type="text" class="form-control tenant-info" placeholder="125 Main St." value={address} onChange={this.handleAddress.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 col-sm-12 col-xs-12">
                                                            <div class="form-group">
                                                                <label for="assignee">Prior City</label>
                                                                <input type="text" class="form-control tenant-info" placeholder="Kansas City" value={city} onChange={this.handleCity.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 col-sm-12 col-xs-12">
                                                            <div class="form-group">
                                                                <UnitedStatesSelect columnSize={0} sortID={state} title="" onChange={this.handleState.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 col-sm-12 col-xs-12">
                                                            <div class="form-group">
                                                                <label for="assignee">Prior Zip</label>
                                                                <input type="text" class="form-control tenant-info" placeholder="65463" value={zip} onChange={this.handleZip.bind(this)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <h4 class="title">Your properties exterior material?</h4>
                                            <div class="row">
                                                <div class="col-md-4 col-md-offset-4">
                                                    <div class="form-group">
                                                        <label for="phone"></label>
                                                        <select class="form-control" value={materialType} onChange={this.handleMaterialChange.bind(this)}>
                                                            <option value='Wood Exterior'>Wood Exterior</option>
                                                            <option value='Brick'>Brick</option>
                                                            <option value='Siding (Aluminum or Plastic)'>Siding (Aluminum or Plastic)</option>
                                                            <option value='Stucco'>Stucco</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="submit" onClick={this.selectStep.bind(this, 4)} name="submit" id="login" class="btn btn-info btn-fill btn-block btn-flat" >Next</button>
                                            <small>This is a non-exclusive offer for renters insurance that is solely recommended, offered, sold, and underwritten by Liberty Mutual Insurance Company and its affiliates. To review the Liberty Mutual Insurance Privacy Policy, <a href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy" target="_blank">click here</a>.  <b>This is a paid advertisement from Liberty Mutual Insurance.</b></small>
                                        </div>
                                    )}
                                    {!this.state.showDisclosure && this.state.step == 4 && (
                                        <div>
                                            <h4 class="title">You can add renters insurance for <b>${policyData.paymentInfo[0].totalAmountDue} / {policyData.paymentInfo[0].paymentFrequency}*</b></h4>
                                            {paymentOptionsHTML}
                                            <small>Click "Purchase" below to buy your Liberty Mutual Renters insurance policy.</small>
                                            <br />
                                            <button type="submit" onClick={this.selectStep.bind(this, 5)} name="submit" id="login" class="btn btn-info btn-fill btn-block btn-flat" >Purchase</button>
                                            <div class="disclosure col-md-12">
                                                <div class="col-md-12">
                                                    <p style={{ textAlign: 'center' }}>If you are no longer interested, close this quote by leaving this page.</p>
                                                </div>
                                            </div>
                                            <small>This is a non-exclusive offer for renters insurance that is solely recommended, offered, sold, and underwritten by Liberty Mutual Insurance Company and its affiliates. To review the Liberty Mutual Insurance Privacy Policy, <a href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy" target="_blank">click here</a>.  <b>This is a paid advertisement from Liberty Mutual Insurance.</b></small>
                                        </div>
                                    )}
                                    {!this.state.showDisclosure && this.state.step == 5 && (
                                        <div>
                                            <h4 class="title">You can add renters insurance for <b>${policyData.paymentInfo[0].totalAmountDue} / {policyData.paymentInfo[0].paymentFrequency}*</b></h4>
                                            {paymentOptionsHTML}
                                            <br />
                                            <div class="col-md-12">
                                                <div class="liberty-mutual-mini-app-container">
                                                    <iframe src={process.env.LIBERTY_MUTUAL_PAYMENT_URL} id="miniAppIframe" width="100%" height="500"></iframe>
                                                </div>
                                            </div>
                                            <small>Review your coverage details, and "Purchase" below to buy your Liberty Mutual Renters insurance policy.</small>
                                            <button type="submit" onClick={this.selectStep.bind(this, 6)} name="submit" id="login" class="btn btn-info btn-fill btn-block btn-flat" >Process Payment</button>
                                            <div class="disclosure col-md-12">
                                                <div class="col-md-12">
                                                    <p style={{ textAlign: 'center' }}>If you are no longer interested, close this quote by leaving this page.</p>
                                                </div>
                                            </div>
                                            <small>This is a non-exclusive offer for renters insurance that is solely recommended, offered, sold, and underwritten by Liberty Mutual Insurance Company and its affiliates. To review the Liberty Mutual Insurance Privacy Policy, <a href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy" target="_blank">click here</a>.  <b>This is a paid advertisement from Liberty Mutual Insurance.</b></small>
                                        </div>
                                    )}
                                    {!this.state.showDisclosure && this.state.step == 7 && (
                                        <div>
                                            <h4 class="title">Congratulations on your new policy!</h4>
                                            <h4 class="title">Policy Number: <b>{purchaseData.policyNumber}</b></h4>
                                            <h4 class="title">Quote Id: <b>{purchaseData.quoteId}</b></h4>
                                            <h4 class="title">Documents: <a href={purchaseData.electronicDocumentsURL}>view</a></h4>
                                            <p>You will receive confirmation of your policy purchase shortly.  If you have any questions about your policy, please contact Liberty Mutual at 1-888-445-6744</p>
                                            <button type="submit" onClick={browserHistory.goBack} name="submit" id="login" class="btn btn-info btn-fill btn-block btn-flat" >Done</button>
                                            <small>This is a non-exclusive offer for renters insurance that is solely recommended, offered, sold, and underwritten by Liberty Mutual Insurance Company and its affiliates. To review the Liberty Mutual Insurance Privacy Policy, <a href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy" target="_blank">click here</a>.  <b>This is a paid advertisement from Liberty Mutual Insurance.</b></small>
                                        </div>
                                    )}
                                    {this.state.showDisclosure && (
                                        <div class="disclosure-text">
                                            <h4 class="link" onClick={this.showDisclosure.bind(this)}>Go back</h4>
                                            <p>
                                                What We Do:
                                                <ul>
                                                    <li>Access consumer report information
                                                        to help determine your price. This includes claims history and credit- based insurance scores when permitted by law.
                                                    </li>
                                                    <li>Access your credit-based insurance score. This score uses information from your credit report to predict how often you are likely to file claims, and how expensive those claims will be.</li>
                                                    <li>Potentially submit your inforsmation to an authorized third party. This allows us to pre-fill your property details. You can choose to allow this when you complete the quote process.</li>
                                                    <li>Potentially share your information with a third party to provide comparison rates and offers from other insurance companies.
                                                        What We Don’t Do:</li>
                                                    <li>Impact your credit rating in any way
                                                        when we access your credit-based
                                                        insurance score.</li>
                                                    <li>Resell or redistribute your credit-
                                                        based insurance score.</li>
                                                </ul>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/views/Tenant/RentersInsurance/LibertyMutual.jsx